import React, { FC } from 'react';
import { Input, PopoverBody, UncontrolledPopover } from 'reactstrap';
import { ProductModel } from '../../../../shared/orders';
import { MaterialIcon } from '../../../components';
import { TranslationKey, useTranslation } from '../../../translations';

interface TableTypeArchiveWarningProps {
  readonly idx: number;
  readonly tableType: Pick<ProductModel, 'deletedAt'>;
}

export const TableTypeArchiveWarning: FC<TableTypeArchiveWarningProps> = ({ idx, tableType }) => {
  const { ts } = useTranslation();
  if (!tableType.deletedAt) {
    return null;
  }

  return (
    <>
      &nbsp;
      <span id={`dealer${idx}TableTypeArchived`}>
        <MaterialIcon name="warning" type="warning" />
      </span>
      <UncontrolledPopover
        placement="bottom"
        target={`dealer${idx}TableTypeArchived`}
        trigger="hover"
      >
        <PopoverBody>
          <p>{ts('this_table_type_has_been')}</p>
          <p>{ts('a_new_currently_active_table')}</p>
        </PopoverBody>
      </UncontrolledPopover>
    </>
  );
};

interface EditEntryProps {
  readonly displayName: TranslationKey;
  readonly name: string;
  readonly value?: string;
  readonly edit: boolean;
  readonly renderEdit?: () => React.JSX.Element;
}

export const EditEntry: FC<EditEntryProps> = ({ displayName, edit, renderEdit, value, name }) => {
  const { ts } = useTranslation();
  return (
    <tr>
      <th scope="row">{ts(displayName)}</th>
      <td id={`dealer-${name}`}>
        {edit && !renderEdit && <Input defaultValue={value ?? ''} id={name} name={name} />}
        {edit && renderEdit?.()}
        {!edit && value}
      </td>
    </tr>
  );
};
